import { pendService } from "services";

import { pendConstants } from "./pend.constants";
import { getPendDetailsPage, getPendHistoryPage } from "./pend.reducer";

export const pendActions = {
	getPend,
	getPendHistory,
	setPagingPendHistory,
	getPendList,
	setPagingPendDetails,
};

function getPend(id) {
	return dispatch => {
		dispatch(request());
		return pendService.getPend(id).then(
			pend => {
				dispatch(success(pend));
				return Promise.resolve(pend);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return {
			type: pendConstants.GET_PEND_REQUEST,
		};
	}

	function success(pend) {
		return {
			type: pendConstants.GET_PEND_SUCCESS,
			pend,
		};
	}

	function failure(error) {
		return {
			type: pendConstants.GET_PEND_ERROR,
			error,
		};
	}
}

function getPendHistory(pageSize, id) {
	return (dispatch, getState) => {
		const state = getState();
		const page = getPendHistoryPage(state);
		dispatch(request());
		return pendService.getPendHistory(page, pageSize, id).then(
			history => {
				dispatch(success(history));
				return Promise.resolve(history);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return {
			type: pendConstants.GET_PEND_HISTORY_REQUEST,
		};
	}

	function success(history) {
		return {
			type: pendConstants.GET_PEND_HISTORY_SUCCESS,
			history,
		};
	}

	function failure(error) {
		return {
			type: pendConstants.GET_PEND_HISTORY_ERROR,
			error,
		};
	}
}

function setPagingPendHistory(page) {
	return {
		type: pendConstants.SET_PAGING_PEND_HISTORY,
		page,
	};
}

function getPendList(name, id, pageSize, excludeStatuses?: string | null) {
	return (dispatch, getState) => {
		const state = getState();
		const page = getPendDetailsPage(state);
		dispatch(request());
		return pendService
			.getPendList({ name, id, page, pageSize, excludeStatuses })
			.then(
				list => {
					dispatch(success(list));
					return Promise.resolve(list);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: pendConstants.GET_PEND_LIST_REQUEST,
		};
	}

	function success(list) {
		return {
			type: pendConstants.GET_PEND_LIST_SUCCESS,
			list,
		};
	}

	function failure(error) {
		return {
			type: pendConstants.GET_PEND_LIST_ERROR,
			error,
		};
	}
}

function setPagingPendDetails(page) {
	return {
		type: pendConstants.SET_PAGING_PEND_DETAILS,
		page,
	};
}
